export default __webpack_public_path__ + "static/blog-post-4-6fc21ee3c69bc8e278f0e8c2f0a555f6.png";